import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { TVendorCpRecord } from "./modal";
import { TDropdown } from "../../shared/modal";
import { Fetch } from "../../utilities/fetch";
import { useToast } from "../../context/toastProvider";

const schema = yup.object({
    name: yup.string().required("Contact Person Name is required*").min(3),
    phoneNo: yup.string().required("Phone Number is required*")
        .matches(/^[0-9-+() ]*$/, "Phone Number can only contain numbers, spaces, and - + ( ) characters")
        .min(7, "Phone Number must be at least 7 digits").max(15, "Phone Number cannot exceed 15 digits"),
    email: yup.string().required().email(),
    vendorCompany: yup.object().shape({
        id: yup.number().min(1, "Vendor Company is required*").required("Vendor Company is required*"),
        name: yup.string().required()
    }),
});

interface Iprops {
    data: TVendorCpRecord,
    open: boolean,
    hideDialog: () => void,
    reload: () => void,
}

export const Form = (props: Iprops) => {
    const [vendorCompanies, setVendorCompanies] = useState<Array<TDropdown>>();
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<TVendorCpRecord>({
        resolver: yupResolver(schema),
        defaultValues: props.data,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.data);
    }, [props.data]);

    const onHide = () => {
        props.hideDialog();
    }

    const loadVendorCompanies = async (filter: string | null) => {
        const data = await Fetch<TDropdown[]>("dropdown/vendorCompanies", {
            query: `filter=${filter}`
        });
        if (data) {
            setVendorCompanies(data);
        }
    }

    const completeMethodVendorCompanies = (event: { query: string }) => {
        loadVendorCompanies(event.query);
    }

    const onSubmit = async (data: TVendorCpRecord) => {
        if (loading) return;
        setLoading(true);

        const id = props.data.id;
        const method = id ? "PUT" : "POST";
        const message = id ? "Updated Successfully" : "Added Successfully";

        data.vendorCompanyId = data.vendorCompany.id;

        const response = await Fetch(id ? `vendorContactPersons/${id}` : 'vendorContactPersons', {
            method,
            body: data,
            onError: (m) => showToast({ severity: 'error', detail: m })
        });

        if (response) {
            props.hideDialog();
            props.reload();
            showToast({ severity: 'success', detail: message });
        }

        setLoading(false);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Vendor Contact Person" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput column={2} required label="Contact Person Name" control={control} name="name" error={errors.name?.message} />
                <JVInput required column={2} label="Email" control={control} name="email" error={errors.email?.message} />
                <JVDropdownInput required column={2} completeMethod={completeMethodVendorCompanies} label="Vendor Company" control={control} name="vendorCompany" error={errors.vendorCompany?.id?.message} options={vendorCompanies} optionLabel="name" placeholder="Search Vendor Company" />

                <JVInput label="Phone No" required column={2} control={control} name="phoneNo" error={errors.phoneNo?.message} />
                <JVInput label="Alternate Phone No" column={2} control={control} name="alternatePhoneNo" error={errors.alternatePhoneNo?.message} />
                <JVInput label="Cell No" column={2} control={control} name="cellNo" error={errors.cellNo?.message} />
                <JVInput label="Major Technology" column={2} control={control} name="majorTech" error={errors.majorTech?.message} />

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>

            </form>
        </Dialog>
    );
}
